import { useMutation } from '@apollo/client';
import { graphql } from '@client/graphql/types';

const DELETE = graphql(`
  mutation deleteNewsBanner($id: ID!) {
    deleteNewsBanner(id: $id) {
      ...NewsBannerItem
    }
  }
`);

export function useDeleteNewsBanner() {
  return useMutation(DELETE, {
    refetchQueries: ['newsBanners', 'newsBanner'],
  });
}
